<template>
    <PlantConfigurationSeasons :plantID="plantID"></PlantConfigurationSeasons>
</template>

<script>
import PlantConfigurationSeasons from '@/components/plants/configuration/PlantConfigurationSeasons.vue';

export default {
    components: {
        PlantConfigurationSeasons
    },
    data() {
        return {
            
        };
    },
    computed: {
        plantID() {
            return parseInt(this.$route.params.plantID);
        }
    },
    methods: {

    },
    created() {
        
    }
}
</script>

<style>

</style>
